import React, { useEffect, useState } from 'react';

// Opt-out for Cloudflare Web Analytics (cookieless). public/analytics.js reads the same key
// and skips loading the beacon; Global Privacy Control is honoured there too.
const KEY = 'bm_analytics_optout';

const read = () => {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
};

export const AnalyticsOptOut: React.FC = () => {
  const [optedOut, setOptedOut] = useState(false);
  const gpc = typeof navigator !== 'undefined' && (navigator as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl;

  useEffect(() => setOptedOut(read()), []);

  const toggle = () => {
    try {
      if (read()) localStorage.removeItem(KEY);
      else localStorage.setItem(KEY, '1');
    } catch {
      // storage blocked: nothing to remember, and the beacon can't persist anything either
    }
    setOptedOut(read());
  };

  if (gpc) {
    return <span className="text-xs text-gray-500">Analytics off (Global Privacy Control)</span>;
  }
  return (
    <button
      type="button"
      onClick={toggle}
      aria-pressed={optedOut}
      className="text-xs text-gray-500 underline hover:text-gray-700"
    >
      {optedOut ? 'Analytics off. Turn back on' : 'Opt out of analytics'}
    </button>
  );
};
